import { render, staticRenderFns } from "./DashboardQueueHeader.vue?vue&type=template&id=3ffcaba1&scoped=true"
import script from "./DashboardQueueHeader.vue?vue&type=script&lang=js"
export * from "./DashboardQueueHeader.vue?vue&type=script&lang=js"
import style0 from "./DashboardQueueHeader.vue?vue&type=style&index=0&id=3ffcaba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffcaba1",
  null
  
)

export default component.exports